import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PartnerCodeInfoStepService } from '../services/partner-code-info-step.service';

@Injectable()
export class PartnerCodeProfileInfoGuard implements CanActivate {

  constructor(
    private partnerCodeInfoStepService: PartnerCodeInfoStepService,
    private router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.partnerCodeInfoStepService.isPartnerCodeProfileInfoAvailable) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
